import { USER_ROLES } from 'src/_shared/constants';

export const DEFAULT_MENUS = {
	[USER_ROLES.EMPLOYEE]: [
		{
			title: 'Dashboard',
			iconType: 'dashboard',
			link: '/dashboard',
		},
		{
			title: 'Referrals',
			iconType: 'group',
			panels: [
				{ title: 'My Referrals', link: '/myreferrals' },
				{ title: 'Referral Network', link: '/mycontacts' },
			],
		},
		{
			title: 'Internal Mobility',
			iconType: 'internal',
			panels: [
				{ title: 'Grow Your Career', link: '/internal' },
				{ title: 'My Applications', link: '/myapplications' },
			],
		},
		{
			title: 'My Bonuses',
			iconType: 'bonus',
			link: '/mybonuses',
		},
	],
	[USER_ROLES.MANAGER]: [
		{
			title: 'Dashboard',
			iconType: 'dashboard',
			link: '/dashboard',
		},
		{
			title: 'Manage Referrals',
			iconType: 'group',
			panels: [
				{ title: 'Referrals', link: '/referrals' },
				{ title: 'Referral Leads', link: '/deck' },
			],
		},
		{
			title: 'Internal Mobility',
			iconType: 'internal',
			panels: [
				{ title: 'Grow Your Career', link: '/internal' },
				{ title: 'Internal Applicants', link: '/internal-applicants' },
				{ title: 'Open To New Roles', link: '/open' },
			],
		},
		{
			title: 'Manage Jobs',
			iconType: 'id',
			link: '/jobs',
		},
	],
	[USER_ROLES.ADMIN]: [
		{
			title: 'Dashboard',
			iconType: 'dashboard',
			link: '/dashboard',
		},
		{
			title: 'Manage Referrals',
			iconType: 'group',
			panels: [
				{ title: 'Referrals', link: '/referrals' },
				{ title: 'Referral Leads', link: '/deck' },
			],
		},
		{
			title: 'Internal Mobility',
			iconType: 'internal',
			panels: [
				{ title: 'Grow Your Career', link: '/internal' },
				{ title: 'Internal Applicants', link: '/internal-applicants' },
				{ title: 'Open To New Roles', link: '/open' },
			],
		},
		{
			title: 'Bonuses',
			iconType: 'bonus',
			panels: [
				{ title: 'All Bonuses', link: '/bonuses' },
				{ title: 'Bonus Campaigns', link: '/bonus-campaigns' },
				{ title: 'Bonus Settings', link: '/builder' },
			],
		},
		{
			title: 'Manage Jobs',
			iconType: 'id',
			link: '/jobs',
		},
		{
			title: 'Message Center',
			iconType: 'messages',
			panels: [{ title: 'Send A Message', link: '/messagecenter' }],
		},
		{
			title: 'Reports',
			iconType: 'reports',
			panels: [
				{ title: 'Report Builder', link: '/report-builder' },
				{ title: 'Report History', link: '/report-history' },
			],
		},
		{
			title: 'Gamification',
			iconType: 'gamification',
			panels: [{ title: 'Points', link: '/points' }],
		},
		{
			title: 'Employees',
			iconType: 'users',
			link: '/employees',
		},
		{
			title: 'Settings',
			iconType: 'settings',
			panels: [
				{ title: 'Settings', link: '/settings' },
				{ title: 'Form Builder', link: '/form-builder' },
				{ title: 'Notifications', link: '/job-notification-email' },
				{ title: 'Companies & Brands', link: '/branding' },
				{ title: 'Custom Pages', link: '/custom-page-builder' },
				{
					title: 'Employee Dashboard',
					link: '/employee-dashboard-settings',
				},
			],
		},
	],
	[USER_ROLES.SUPER_ADMIN]: [
		{
			title: 'Admin Console',
			iconType: 'id-card',
			link: '/admin-console',
		},
		{
			title: 'Dashboard',
			iconType: 'dashboard',
			link: '/dashboard',
		},
		{
			title: 'Recognition Admin',
			iconType: 'award',
			panels: [
				{ title: 'All Recognitions', link: '/recognition-approvals' },
				{ title: 'Manage Recognitions', link: '/manage-recognitions' },
				{ title: 'Recognition Users', link: '/employee-manager' },
				{ title: 'Nominations', link: '/nominations' },
				{ title: 'Snappy History', link: '/snappy-history' },
				{ title: 'Settings', link: '/recognition-settings' },
			],
		},
		{
			title: 'Manage Referrals',
			iconType: 'group',
			panels: [
				{ title: 'Referrals', link: '/referrals' },
				{ title: 'Referral Leads', link: '/deck' },
			],
		},
		{
			title: 'Internal Mobility',
			iconType: 'internal',
			panels: [
				{ title: 'Grow Your Career', link: '/internal' },
				{ title: 'Internal Applicants', link: '/internal-applicants' },
				{ title: 'Open To New Roles', link: '/open' },
			],
		},
		{
			title: 'Bonuses',
			iconType: 'bonus',
			panels: [
				{ title: 'All Bonuses', link: '/bonuses' },
				{ title: 'Bonus Campaigns', link: '/bonus-campaigns' },
				{ title: 'Bonus Settings', link: '/builder' },
			],
		},
		{
			title: 'Manage Jobs',
			iconType: 'id',
			link: '/jobs',
		},
		{
			title: 'Message Center',
			iconType: 'messages',
			panels: [{ title: 'Send A Message', link: '/messagecenter' }],
		},
		{
			title: 'Reports',
			iconType: 'reports',
			panels: [
				{ title: 'Report Builder', link: '/report-builder' },
				{ title: 'Report History', link: '/report-history' },
			],
		},
		{
			title: 'Gamification',
			iconType: 'gamification',
			panels: [
				{ title: 'Points', link: '/points' },
				{ title: 'Rewards Store', link: '/rewards-store' },
			],
		},
		{
			title: 'Employees',
			iconType: 'users',
			link: '/employees',
		},
		{
			title: 'Settings',
			iconType: 'settings',
			panels: [
				{ title: 'Settings', link: '/settings' },
				{ title: 'Form Builder', link: '/form-builder' },
				{ title: 'Notifications', link: '/job-notification-email' },
				{ title: 'Companies & Brands', link: '/branding' },
				{ title: 'Custom Pages', link: '/custom-page-builder' },
				{
					title: 'Employee Dashboard',
					link: '/employee-dashboard-settings',
				},
			],
		},
	],
};

export const AVAILABLE_ICONS = [
	'ondeck',
	'add-button',
	'cancel-button',
	'dashboard',
	'dashboardnew',
	'career',
	'bonus',
	'download-arrow',
	'email-filled',
	'email-outline',
	'edit',
	'eye',
	'facebook-logo',
	'folder',
	'gas',
	'google-plus',
	'group',
	'id-card',
	'id',
	'settings',
	'share',
	'sort-down',
	'tick-inside-circle',
	'twitter',
	'up-arrow',
	'user-black',
	'user',
	'sad',
	'magnifying-glass',
	'users',
	'linked-in',
	'minus-symbol',
	'network',
	'placeholder',
	'plus-symbol',
	'reports',
	'ring',
	'checkmark',
	'right-arrow',
	'pencil-edit-button',
	'messages',
	'lock',
	'contacts',
	'shoppingBag',
	'customPage',
	'announcements',
	'internal',
	'gamification',
	'award',
];

export const AVAILABLE_ROUTES = [
	{ value: '/admin-console', label: 'Admin Console' },
	{ value: '/bonuses', label: 'All Bonuses' },
	{ value: '/recognition-approvals', label: 'All Recognitions' },
	{ value: '/announcements', label: 'Announcements' },
	{ value: '/bonus-campaigns', label: 'Bonus Campaigns' },
	{ value: '/builder', label: 'Bonus Settings' },
	{ value: '/browsejobs', label: 'Browse Jobs' },
	{ value: '/candidates', label: 'Candidates' },
	{ value: '/branding', label: 'Companies & Brands' },
	{ value: '/custom-page-builder', label: 'Custom Pages Editor' },
	{ value: '/dashboard', label: 'Dashboard' },
	{ value: '/employee-dashboard-settings', label: 'Employee Dashboard' },
	{ value: '/employees', label: 'Employees' },
	{ value: '/form-builder', label: 'Form Builder' },
	{ value: '/giftcardstore', label: 'Gift Card Store' },
	{ value: '/internal-applicants', label: 'Internal Applicants' },
	{ value: '/internal', label: 'Internal Mobility' },
	{ value: '/jobs', label: 'Manage Jobs' },
	{ value: '/manage-milestones', label: 'Manage Milestones' },
	{ value: '/manage-recognitions', label: 'Manage Recognitions' },
	{ value: '/messagecenter', label: 'Message Center' },
	{ value: '/myapplications', label: 'My Applications' },
	{ value: '/mybonuses', label: 'My Bonuses' },
	{ value: '/my-recognitions', label: 'My Recognitions' },
	{ value: '/myreferrals', label: 'My Referrals' },
	{ value: '/my-team', label: 'My Team' },
	{ value: '/nominations', label: 'Nominations' },
	{ value: '/job-notification-email', label: 'Notifications' },
	{ value: '/open', label: 'Open To New Roles' },
	{ value: '/points', label: 'Points' },
	{ value: '/recognition-hub', label: 'Recognition Hub' },
	{ value: '/recognition-settings', label: 'Recognition Settings' },
	{ value: '/employee-manager', label: 'Recognition Users' },
	{ value: '/recognitions', label: 'Recognitions' },
	{ value: '/deck', label: 'Referral Leads' },
	{ value: '/mycontacts', label: 'Referral Network' },
	{ value: '/referrals', label: 'Referrals' },
	{ value: '/report-builder', label: 'Report Builder' },
	{ value: '/report-history', label: 'Report History' },
	{ value: '/reports', label: 'Reports' },
	{ value: '/rewards-store', label: 'Rewards Store' },
	{ value: '/approvals-bonus', label: 'Send Recognition' },
	{ value: '/settings', label: 'Settings' },
	{ value: '/snappy-history', label: 'Snappy History' },
];
